import script from "./action-generate.vue?vue&type=script&setup=true&lang=js"
export * from "./action-generate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__